var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsPluginLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.5 19H4.8c-.477 0-.935-.19-1.273-.527C3.19 18.135 3 17.677 3 17.2v-6.3c0-.477.19-.935.527-1.273.338-.337.796-.527 1.273-.527h2.7m6.3-1.8V3.7c0-.716-.285-1.403-.79-1.91-.507-.506-1.194-.79-1.91-.79L7.5 9.1V19h10.152c.434.005.855-.147 1.186-.428.33-.282.549-.673.614-1.102l1.242-8.1c.039-.258.022-.521-.051-.772-.073-.25-.2-.482-.37-.68-.172-.196-.384-.354-.622-.46-.238-.107-.496-.161-.757-.158H13.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPluginLike);
export default __webpack_public_path__ + "static/media/icons_plugin_like.7d68d9992c5a370fc2dfb445213a0e0d.svg";
export { ForwardRef as ReactComponent };